module.exports = __webpack_public_path__ + "img/footerErWeiMa_h2.f02e1c34.png";